import React, { useState } from 'react';

import LikeInstructionsIcon from './icons/LikeInstructions';
import DislikeInstructionsIcon from './icons/DislikeInstructions';

import CloseIcon from './icons/Close';

import './SwipeInstructions.scss';

const SwipeInstructions = () => {
  const [instructionsRead, setInstructionsRead] = useState(false);

  return !instructionsRead ? (
    <div
      className="swipe-instructions"
      onClick={() => setInstructionsRead(true)}
      role="button"
      tabIndex={0}
    >
      <span
        className="swipe-instructions__close"
        onClick={() => setInstructionsRead(true)}
        role="button"
        tabIndex={0}
      >
        <CloseIcon color="white" />
      </span>
      <LikeInstructionsIcon className={'swipe-instructions__like'} />
      <DislikeInstructionsIcon className={'swipe-instructions__dislike'} />
    </div>
  ) : null;
};

export default SwipeInstructions;
